module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_3016.5e95d7c2.png";